<template>
  <d-form @submit.prevent="save" class="px-3">
    <d-form-row class="d-flex align-items-center ml-2">
      <d-col
        md="4"
        class="d-flex justify-content-center-center align-items-center"
      >
        <d-checkbox
          toggle
          :checked="coversEntireState"
          @change="handleCheck"
          class="custom-toggle-sm"
        >
          <span>Atende todo o Estado</span>
        </d-checkbox>
      </d-col>
      <d-col md="4" v-if="coversEntireState">
        <select-state
          :model.sync="state"
          :onChange="onChangeStates"
        ></select-state>
      </d-col>
      <d-col md="4" v-if="coversEntireState">
        <d-button type="submit" class="btn-primary mt-2 mt-md-0">
          Adicionar
        </d-button>
      </d-col>
    </d-form-row>
    <d-form-row v-if="coversEntireState" class="ml-2">
      <d-col md="12" class="d-flex mt-4 flex-wrap">
        <div
          v-for="(state, index) in model.whole_states"
          :key="index"
          class="custom_items"
        >
          <div class="align-center">
            <span>{{ state }}</span>
            <span
              class="label delete cursor-pointer ml-2"
              @click="deleteState(state)"
            >
              <i class="material-icons">delete</i>
            </span>
          </div>
        </div>
      </d-col>
    </d-form-row>
    <cities v-if="coversEntireState === false"></cities>
  </d-form>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import SelectState from '_shared/SelectState.vue';
import Cities from './Cities.vue';
import { REGIONS, _LOAD_MODEL_ } from './DistributorModel';

export default {
  name: 'regions',
  components: {
    SelectState,
    Cities,
  },
  data() {
    return {
      state: null,
      coversEntireState: null,
      stateSelected: [],
    };
  },
  props: {
    model: {
      type: Object,
      default: () => ({ ...REGIONS }),
      required: true,
    },
  },
  computed: {},
  methods: {
    ...mapActions([
      'activeAlert',
      'syncAttacherRegions',
      'getAttachedRegions',
      'setAttachedRegions',
      'saveStates',
      'setToggle',
    ]),
    handleCheck(value) {
      this.coversEntireState = value;
    },
    save() {
      const states = [...this.model.whole_states, this.state];
      this.saveStates({
        states,
        id: parseInt(this.$route.params.id, Number),
      });
      this.model.whole_states = states;
      this.state = null;
    },
    onChangeStates(value) {
      this.state = value;
    },
    deleteState(type) {
      const states = this.model.whole_states.filter(item => item !== type);
      this.model.whole_states = states;
      this.saveStates({
        states,
        id: parseInt(this.$route.params.id, Number),
      });
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, distributor => {
      this.coversEntireState = distributor.whole_states.length > 0;
    });
  },
  destroyed() {
    Events.$off(_LOAD_MODEL_);
  },
};
</script>
<style lang="scss" scoped>
@import '~_scss/overrides';
.align-center {
  vertical-align: middle;
}
.custom_items {
  padding: 8px;
  border: 1px dashed #dfe0e0;
  border-radius: 4px;
  margin-right: 5px;
  margin-bottom: 10px;
  background: $primary;
  color: #fff;
  font-size: 12px;
  cursor: default;
  &:hover {
    background: #0a56b4;
  }
}
</style>
